import { render, staticRenderFns } from "./PersonTabNav.vue?vue&type=template&id=db5d1f16&scoped=true&"
import script from "./PersonTabNav.vue?vue&type=script&lang=js&"
export * from "./PersonTabNav.vue?vue&type=script&lang=js&"
import style0 from "./PersonTabNav.vue?vue&type=style&index=0&id=db5d1f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5d1f16",
  null
  
)

component.options.__file = "PersonTabNav.vue"
export default component.exports